import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import firebase from 'firebase'
let app;
Vue.config.productionTip = false
//intalize firebase
const config = {
  apiKey: "AIzaSyALK2NtFLbrCjcZtw2JW6TdD40JFceb5hU",
  authDomain: "lwhs-compsci-demo.firebaseapp.com",
  databaseURL: "https://lwhs-compsci-demo.firebaseio.com",
  projectId: "lwhs-compsci-demo",
  storageBucket: "lwhs-compsci-demo.appspot.com",
  messagingSenderId: "891951067851"
};
firebase.initializeApp(config);

//only initialize app if firebase is loaded
firebase.auth().onAuthStateChanged((user) => {
  if (!app) {
    app = new Vue({
      render: h => h(App)
    }).$mount('#app')

  }
})
